import { getLibrarySystemClient } from "@libry-content/integrations";
import { useMemo } from "react";
import { useCommonData } from "../../components/layout/CommonDataProvider";

export const useLibrarySystemClient = () => {
  const { site } = useCommonData();
  const librarySystem = useMemo(() => site && getLibrarySystemClient(site.librarySystem), [site]);
  return librarySystem;
};
